var angular = require('angular');
var Address = require('lana');
var _module = angular.module('listreports.report', []);
var _       = require('lodash');

require('../core/utils');


_module
    .factory('$report', [
        '$log',
        '$q',
        '$http',
        '$utils',

        function($log, $q, $http, $utils) {
            var API_URL = "https://www.listreports.com";
            var GALLERY_URL = "https://s3-us-west-2.amazonaws.com/edge.listreports.com/comarketing/";

            return {
                _getConfig: function(reportId) {
                    var defer = $q.defer();

                    $http.get(GALLERY_URL + reportId + '/info.json')
                        .then(
                            function(response) {
                                defer.resolve(response.data);
                            },
                            function() {
                                console.log('No property config found.');
                                defer.resolve({});
                            }
                        )
                    ;

                    return defer.promise;
                },

                _getEnhancedGallery: function(reportId) {
                    var defer  = $q.defer();
                    var count  = 1;
                    var images = [];
                    var config = {};
                    var _this  = this;

                    function getImage() {
                        var image = GALLERY_URL + reportId + '/' + count + '.jpg';

                        $utils.isImage(image)
                            .then(
                                function() {
                                    images.push(image);
                                    count++;
                                    getImage();
                                },
                                function() {
                                    defer.resolve(images);
                                }
                            )
                        ;
                    }

                    _this._getConfig(reportId)
                        .then(
                            function(response) {
                                config = response;

                                if(config && angular.isDefined(config.enhanced_gallery_count)) {
                                    images = [];

                                    for(var i=1; i<=Number(config.enhanced_gallery_count); i++) {
                                        images.push(GALLERY_URL + reportId + '/' + i + '.jpg');
                                    }

                                    defer.resolve(images);
                                } else {
                                    getImage();
                                }
                            },
                            defer.reject
                        )
                    ;

                    return defer.promise;
                },

                _getBackgroundImage: function(reportId) {
                    var defer  = $q.defer();

                    var image = GALLERY_URL + reportId + '/background.jpg';

                    $utils.isImage(image)
                        .then(
                            function() {
                                defer.resolve(image);
                            },
                            function() {
                                defer.resolve('images/default-background.jpg');
                            }
                        )
                    ;

                    return defer.promise;
                },

                _getCoordinates: function(reportId) {
                    var defer  = $q.defer();

                    $http.get(API_URL + '/v1/reports/' + reportId + '/coordinates')
                        .then(
                            function(response) {
                                defer.resolve(response.data.coordinates);
                            },
                            defer.reject
                        )
                    ;

                    return defer.promise;
                },

                _getAgentAffiliateCode: function(report) {
                    if(report.agent && report.agent.agent_user_id) {
                        return $http.get(API_URL + '/v1/affiliatecodes/' + report.agent.agent_user_id)
                        .then(function (response) {
                            if(response && response.data){
                                return response.data.affiliate_code || null;
                            } else {
                                // returning resolved agent affiliate code
                                return response;
                            }
                        })
                        .catch(function(err) {
                            $log.error('_getAgentAffiliateCode Error:', err);
                            return null;
                        });
                    } else {
                        return $q.when(null);
                    }
                },

                _getNestAffiliateCode: function(report) {
                    var _hasNestMeAccess = function (user) {
                        return (user && user.role && user.role.acls &&
                            user.role.acls.nestme && user.role.acls.nestme.access === true);
                    };

                    var _hasShowNestmeButton = function (user) {
                        return (user && user.role && user.role.acls &&
                            user.role.acls.property_website && user.role.acls.property_website.see_similar_homes_button === 'show');
                    };

                    if(report.agent && report.agent.agent_user_id) {

                        return $http.get(API_URL + '/v1/affiliatecodes/' + report.agent.agent_user_id)
                            .then(function(response) {
                                if(response && response.data && _hasShowNestmeButton(response.data)) {
                                    return response.data.affiliate_code || null;
                                } else {
                                    // the agent has no nest.me access so we fall back to comarketer
                                    return $http.get(API_URL + '/v1/affiliatecodes/' + report.comarketer.vendor_user_id);
                                }
                            })
                            .then(function (response) {
                                if(response && response.data){
                                    if(_hasShowNestmeButton(response.data)) {
                                        return response.data.affiliate_code || null;
                                    } else {
                                        return null;
                                    }
                                } else {
                                    // returning resolved agent affiliate code
                                    return response;
                                }
                            })
                            .catch(function(err) {
                                $log.error('_getNestAffiliateCode Error:', err);
                                return null;
                            });

                    } else {
                        // possibly a report owned by a vendor user whose agent hasn't accepted the offer yet,
                        // so we return the owner's affiliate code if they have nest.me access

                        if(!_hasShowNestmeButton(report.owner)) {
                            return $q.when(null);
                        } else if(report.owner.affiliate_code && (report.owner.benoitPartnerId || report.owner.vendorId)) {
                            return $q.when(report.owner.affiliate_code);
                        } else {
                            return $q.when(null);
                        }
                    }
                },

                _isAddonActive: function(report, planId) {
                    if(report.agent && report.agent.agent_user_id) {
                        var agentId = report.agent.agent_user_id || '';
                        return $http.get(API_URL + '/v1/users/' + agentId + '/addon-subscriptions/' + planId + '/is-active')
                        .then(function(response) {
                            return response.data.active;
                        })
                        .catch(function(err) {
                            $log.error('_isAddonActive Error:', err);
                            return false;
                        });
                    } else {
                        return $q.when(false);
                    }
                },

                _checkLeadGenSubscription: function(report) {
                    return this._isAddonActive(report, 'Home Report Lead Gen');
                },

                _checkPairedFeaturesAccess: function(report) {
                    var self = this;
                    if(
                        _.get(report, 'owner.vendorId') ||
                        _.get(report, 'owner.preferredVendorId') ||
                        $utils.isInIframe()
                    ) {
                        return $q.when(true);
                    } else {
                        return $q.all([
                            self._isAddonActive(report, 'Agent Partner Program'),
                            self._isAddonActive(report, 'Paired Features Temporary Access'),
                        ])
                        .then(function (responses) {
                            return responses.some(Boolean);
                        });
                    }
                },

                _sanitizeEnhancedGallery: function(enhancedGallery) {

                    // Removes any broken images by validating all image URLs

                    var validationPromises = (enhancedGallery || []).map(function (image) {
                        return $utils.isImage(image)
                            .then(function () { return image; })
                            .catch(function () {
                                $log.warn('_sanitizeEnhancedGallery -> Removing invalid image -> ', image);
                                return false;
                            });
                    });
                    return $q.all(validationPromises)
                        .then(function (response) {
                            return response.filter(Boolean);
                        })
                        .catch(function (err) {
                            $log.error('_sanitizeEnhancedGallery', err && err.stack);
                            return enhancedGallery;
                        });
                },

                _sanitizeBackgroundImage: function (backgroundImage) {
                    return $utils.isImage(backgroundImage)
                        .then(function() { return backgroundImage; })
                        .catch(function () {
                            $log.warn('_sanitizeBackgroundImage -> Removing invalid backgroundImage -> ', backgroundImage);
                            return 'images/default-background.jpg';
                        });
                },

                get: function(reportId) {
                    var _this  = this;
                    var report = null;

                    // The following code still supports backwards compatibility from when we
                    // had to check the images on s3.

                    return $http.get(API_URL + '/v1/reports/' + reportId)
                    .then(
                        function(response) {
                            report = response.data;
                            if(report.archived === true) {
                                throw new Error('Report Was Archived');
                            }
                            report.meta = report.meta || {};
                            var funcs = {
                                affiliate_code: _this._getNestAffiliateCode(report),
                                agent_affiliate_code: _this._getAgentAffiliateCode(report),
                                isLeadGenSubscribed: _this._checkLeadGenSubscription(report),
                                pairedFeaturesAccess: _this._checkPairedFeaturesAccess(report),
                            };

                            try {
                                report.meta.zip_code = report.address.match(/(\d){5}$/)[0];
                            } catch (err) {
                                report.meta.zip_code = null;
                            }

                            if(!angular.isDefined(report.coordinates) || report.coordinates.lat === 0 || report.coordinates.lng === 0) {
                                funcs.coordinates = _this._getCoordinates(reportId);
                            }

                            if(!angular.isDefined(report.images.enhanced_gallery) || report.images.enhanced_gallery.length === 0) {
                                funcs.enhancedGallery = _this._getEnhancedGallery(reportId);
                            } else {
                                funcs.enhancedGallery = _this._sanitizeEnhancedGallery(report.images.enhanced_gallery);
                            }

                            if(!angular.isDefined(report.images.hero)) {
                                funcs.heroImage = _this._getBackgroundImage(reportId);
                            } else {
                                funcs.heroImage = _this._sanitizeBackgroundImage(report.images.hero);
                            }

                            if(report.address) {
                                var addressParts = new Address(report.address);
                                report.addressParts = addressParts;
                            }

                            return $q.all(funcs);
                        }
                    )
                    .then(
                        function(response) {
                            if(angular.isDefined(response.affiliate_code))
                                report.meta.affiliate_code = response.affiliate_code;

                            if(angular.isDefined(response.agent_affiliate_code))
                                report.meta.agent_affiliate_code = response.agent_affiliate_code;

                            if(angular.isDefined(response.isLeadGenSubscribed))
                                report.meta.isLeadGenSubscribed = response.isLeadGenSubscribed;

                            if(angular.isDefined(response.coordinates))
                                report.coordinates = response.coordinates;

                            if(angular.isDefined(response.enhancedGallery))
                                report.images.enhanced_gallery = response.enhancedGallery;

                            if(angular.isDefined(response.heroImage))
                                report.images.hero = response.heroImage;

                            if(!angular.isDefined(report.comarketed_products) || !report.comarketed_products)
                                report.comarketed_products = {
                                    property_website: true
                                };

                            if(!angular.isDefined(report.comarketed_products.property_website))
                                report.comarketed_products.property_website = true;

                            report.meta.pairedFeaturesAccess = response.pairedFeaturesAccess;

                            return report;
                        }
                    );
                }
            };
        }
    ])
;


module.exports = _module;
